// @core/api/endpoints/secret/list_policies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPoliciesResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * List access policies
 * Returns all access policies.
 */
export async function ListPolicies(
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListPoliciesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/policies`;
  const requestOptions = options;
  return client.get<ListPoliciesResponse>(requestPath, { ...requestOptions, params });
}
